module.exports = __webpack_public_path__ + "static/media/thumb_truck.4cb33962.png";